import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "dev-card" }
const _hoisted_4 = { class: "dev-icon" }
const _hoisted_5 = { class: "dev-info" }
const _hoisted_6 = { class: "dev-name" }
const _hoisted_7 = { class: "dev-role" }

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DescriptionSection',
  setup(__props) {

const { t } = useI18n();
const expanded = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(["desc", { clamped: !expanded.value }])
    }, [
      _createElementVNode("span", {
        innerHTML: _unref(t)('download.appDataContent')
      }, null, 8, _hoisted_2),
      _createElementVNode("span", {
        class: "toggle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
      }, _toDisplayString(expanded.value ? _unref(t)('common.less') : _unref(t)('common.more')), 1)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_icon, {
          name: "user-o",
          size: "20",
          color: "#6b7280"
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)('donwload.appName')), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('appStore.developerRole')), 1)
      ]),
      _createVNode(_component_van_icon, {
        name: "arrow",
        size: "16",
        color: "#9ca3af"
      })
    ])
  ]))
}
}

})